import { pathSubscription } from 'nike-re-framejs';
import forumClient from '../../common/axios/forumClient';
import { indexById } from '../turboLive/push/indexingUtils';
import { dispatch } from 'nike-re-framejs';
export const getModalPost$ = (postId: number) => pathSubscription(['betbook', 'modal', '' + postId]);

export const loadBetbookModalPost = (postId: number) => {
    forumClient.get('/v5/betbook/analyses', { params: { ids: postId } }).then(post => dispatch(setModalPost(post)));
};

export const setModalPost = post => db => db.setIn(['betbook', 'modal'], indexById(post));

export const postsModalClean = () => db => db.removeIn(['betbook', 'modal']);
